import {  } from "helpers/url_helper";

import {
POST_SENTRY_SERVICE_MAPPING,
POST_SENTRY_SERVICE_MAPPING_SUCCESS,
POST_SENTRY_SERVICE_MAPPING_FAIL,
GET_SENTRY_PROJECTS,
GET_SENTRY_PROJECTS_SUCCESS,
GET_SENTRY_PROJECTS_FAILURE,
} from "./actionTypes";


  export const getSentryProjects = () => ({
    type: GET_SENTRY_PROJECTS,
  });

  export const getSentryProjectsSuccess = (data) => ({
    type: GET_SENTRY_PROJECTS_SUCCESS,
    payload: data,
  });

  export const getSentryProjectsFail = error => ({
    type: GET_SENTRY_PROJECTS_FAILURE,
    payload: error,
  });

  export const postSentryServiceMapping = (service_mapping) => ({
      type: POST_SENTRY_SERVICE_MAPPING,
      payload: { service_mapping }
    });

  export const postSentryServiceMappingFail = error => ({
    type: POST_SENTRY_SERVICE_MAPPING_FAIL,
    payload: error,
  });

  export const postSentryServiceMappingSuccess = sentry_projects => ({
    type: POST_SENTRY_SERVICE_MAPPING_SUCCESS,
    payload: sentry_projects,
  });